import { createAction } from '@reduxjs/toolkit'

export const updateUser = createAction('updateUser')
export const deleteUser = createAction('deleteUser')